import React from "react"
import { BeneficiaryStatus } from "~Components/layout/partials/banners/beneficiaryStatus.banner"
import { DatevOnlineErrorBanner } from "~Components/layout/partials/banners/datevOnlineError.banner"
import { SpreadsheetImportInProgressBanner } from "~Components/layout/partials/banners/spreadsheetImportInProgress.banner"
import WeavrOnBoardingBanner from "~Components/layout/partials/banners/weavrOnBoarding.banner"
import { ActiveSubstitutionBanner } from "~Features/settings/absenceManagement/ActiveSubstitutionBanner"
import { BillingPaymentSignUpBanner } from "~Features/settings/billing/billingPaymentSignUp.banner"

export const BannerContainer = () => (
    <div className="finway-global-banner mx-10 md:mx-0">
        <ActiveSubstitutionBanner />
        <BillingPaymentSignUpBanner />
        <WeavrOnBoardingBanner />
        <SpreadsheetImportInProgressBanner />
        <DatevOnlineErrorBanner />
        <BeneficiaryStatus />
    </div>
)
